
const LocalizedStrings = {
    'fi-FI': {
        'login.login': 'KIRJAUDU',
        'login.tosernet': 'SERNETIIN',
        'login.insertcredentials': 'Syötä käyttäjätunnukset',
        'login.email': 'Sähköposti',
        'login.password': 'Salasana',
        'login.loginbutton': 'Sisään',
        'desktop.handlerreports': 'Käsittelijäraportit',
        'desktop.logout': 'Kirjaudu ulos',
        'desktop.receivereports': 'Vastaanottoraportit',
        'desktop.info': ' ',
        'desktop.settings': 'Hallinta',
        'desktop.sortsummaryreports': 'Sisäiset raportit',
        'reports.todesktop': 'Työpöydälle',
        'home.frontpage': 'Työpöytä',
        'handlerreports.import': 'Tietojen tuonti',
        'handlerreports.browse': 'Tietojen selaaminen',
        'handlerreports.history': 'Aiemmat raportit',
        'handlerreports.header': 'Käsittelijäraportit',
        'handlerreports.import.header': 'Tuonti',
        'handlerreports.import.sorter': 'Käsittelijä',
        'handlerreports.import.reportmonth': 'Raportointikuukausi',
        'handlerreports.import.importreport': 'Tuo raporttitiedot',
        'handlerreports.import.uploadfile': 'Lataa tiedosto',
        'handlerreports.import.send': 'Tuo',
        'handlerreports.import.sending': 'Tallennetaan käsittelijäraportti...',
        'handlerreports.import.resulttable.checksum': 'TARKASTUSSUMMA',
        'handlerreports.import.resulttable.classedser': 'Luokiteltu SER',
        'handlerreports.import.resulttable.crt': 'TVt ja näytöt (CRT)',
        'handlerreports.import.resulttable.sda': 'Pien-SER (SDA)',
        'handlerreports.import.resulttable.lda': 'Kodinkoneet (LDA)',
        'handlerreports.import.resulttable.cold': 'Kylmälaitteet (COLD)',
        'handlerreports.import.resulttable.ce': 'Viihde-elektroniikka (Ce)',
        'handlerreports.import.resulttable.solar': 'Aurinkopaneelit (SOLAR)',
        'handlerreports.import.resulttable.scrap': 'Luokittelematon SER (SCRAP)',
        'handlerreports.import.resulttable.sum': 'Yhteensä',
        'handlerreports.import.resulttable.kg': 'kg',
        'handlerreports.import.resulttable.summismatch': 'Yhteenlasketut painokilot eivät vastaa raportin kokonaispainoa.',
        'handlerreports.import.accept':'Hyväksy ja tallenna',
        'handlerreports.import.reject':'Hylkää',
        'handlerreports.import.saving':'Tallennetaan käsittelijäraporttitiedot...',
        'handlerreports.import.ready':'Raportit tallennettu',
        'handlerreports.import.rejectreport':'Hylkää käsittelijäraportti?',
        'handlerreports.import.rejectreporttext':'Raportin hylkääminen poistaa kaikki tuodut käsittelijäraportin tiedot. Lataa lisää tiedostoja valitsemalla Muokkaa.',
        'handlerreports.import.edit':'Muokkaa',
        'handlerreports.import.error':'Tietokantaan tallennuksessa tapahtui virhe.',
        'report-type.SERTY': 'SERTY',
        'report-type.LAPLAND': 'Lapinkeräys',
        'report-type.HYVASER': 'Hyvä-SER',
        'report-type.STORE': 'Kauppakeräys',
        'report-type.OMASER': 'Oma keräys',
        'report-type.POPUP': 'Pop up -keräys',
        'report-type.choose': '- Valitse tyyppi -',
        'sorter-list.choose': '- Valitse käsittelijä -',
        'handlerreports.browse.header': 'Selaaminen',
        'handlerreports.browse.sorter': 'Käsittelijä',
        'handlerreports.browse.startmonth': 'Alkukuukausi',
        'handlerreports.browse.endmonth': 'Loppukuukausi',
        'handlerreports.browse.monthrange': 'Raportointiväli',
        'handlerreports.browse.reporttypes': 'Raporttityypit',
        'handlerreports.browse.get': 'Hae',
        'handlerreports.browse.getting': 'Haetaan käsittelijäraporttitietoja...',
        'handlerreports.browse.clear': 'Tyhjennä',
        'handlerreports.browse.datatable.handlerid': 'ID Käsittelijä',
        'handlerreports.browse.datatable.handlername': 'Käsittelijä',
        'handlerreports.browse.datatable.stationid': 'ID Käsittelyasema',
        'handlerreports.browse.datatable.stationname': 'Käsittelyasema',
        'handlerreports.browse.datatable.operatorname': 'Jätehuoltoyhtiö',
        'handlerreports.browse.datatable.operatorid': 'ID Jätehuoltoyhtiön',
        'handlerreports.browse.datatable.collectionpointid': 'ID Keräyspiste',
        'handlerreports.browse.datatable.collectionpointname': 'Keräyspiste',
        'handlerreports.browse.datatable.category': 'Nimike',
        'handlerreports.browse.datatable.type': 'Tyyppi',
        'handlerreports.browse.datatable.date': 'PVM',
        'handlerreports.browse.datatable.weightkg': 'Paino (kg)',
        'handlerreports.browse.datatable.documentid': 'Asiakirjanumero',
        'filetransfer.error.excelNotRecognised': 'Väärän muotoinen tiedosto, onko käsittelijä oikea?',
        'filetransfer.error.rowParsingError': 'Virhe tiedoston lukemisessa, rivi(t):',
        'filetransfer.error.reportRowParsingError': 'Virhe raportilla, rivi(t):',
        'filetransfer.error.storeReportRowParsingError': 'Virhe kauppakeräysraportilla, rivit(t):',
        'filetransfer.error.findStreamError': 'Nimikkeen lukemisessa virhe.',
        'filetransfer.error.row.101': 'Vastaanottopaikan ID ei löydy',
        'filetransfer.error.row.102': 'Kauppakeräyspisteen ID ei löydy',
        'filetransfer.error.row.103': 'Nimikettä (stream) ei löydy',
        'filetransfer.error.row.104': 'Keräyspisteen ID ei löydy',
        'filetransfer.error.row.105': 'Kaudelle ei raportilla yhtään riviä',
        'filetransfer.error.row.201': 'Päivämäärävirhe (pvm - rivi - ID)',
        'filetransfer.error.row.202': 'Summavirhe (kilot)',
        'filetransfer.error.row.203': 'Nimike (stream) ei löydy (kausi)',
        'filetransfer.error.row.204': 'Kiloissa virhe (ei numero)',
        'filetransfer.error.invalidSERType': 'Väärä SER-tyyppi',
        'filetransfer.error.transfer': 'Virhe ladatessa tiedostoa',
        'filetransfer.error.invalidPeriod': 'Raportin laskutuskauden päivämäärät ovat väärässä muodossa. Hyväksyttävät muodot ovat “1.2.-28.2.2021” ja “Helmikuu 2021”. Väärän muotoinen kausi: ',
        'nav.home': 'Työpöytä',
        'nav.reports': 'Raportointi',
        'nav.settings': 'Hallinta',
        'nav.sortsummaryreports': 'Sisäisen laskennan raportit',
        'receptionreports.manager': 'Vastaanottoraportointi',
        'receptionreports.browse': 'Valmiit raportit',
        'receptionreports.header': 'Vastaanottoraportit',
        'receptionreports.manage.header': 'Hallinta',
        'receptionreports.manage.manual': 'Kertaraportit',
        'receptionreports.manage.manual.tip': 'Anna raportointiväli ja valitse sitten alla olevasta listasta jätehuoltoyhtiö-rivit. Merkitse @-sarakkeeseen ruksi, jos raportti lähetetään sähköpostitse jätehuoltoyhtiön tiedoissa annettuihin osoitteisiin. Raportti luodaan kun painat Raportoi-painiketta.',
        'receptionreports.manage.monthly': 'Kuukausiraportit',
        'receptionreports.manage.quarterly': 'Kvartaaliraportit',
        'receptionreports.manage.yearly': 'Vuosiraportit',
        'receptionreports.manage.monthly.tip': 'Anna kuukausiraportin lähetysaikataulu ja valitse sitten alla olevasta listasta jätehuoltoyhtiö-rivit. Merkitse @-sarakkeeseen ruksi, jos raportti lähetetään sähköpostitse jätehuoltoyhtiön tiedoissa annettuihin osoitteisiin. Raportti luodaan automaattisesti lähetysajankohtana.',
        'receptionreports.manage.auto': 'Automaattiset raportit',
        'receptionreports.manage.auto.tip': 'Anna automaattisten raporttien lähetysaikataulut ja valitse sitten alla olevasta listasta jätehuoltoyhtiö-rivit. Merkitse @-sarakkeeseen ruksi, jos raportti lähetetään sähköpostitse jätehuoltoyhtiön tiedoissa annettuihin osoitteisiin. Raportti luodaan automaattisesti lähetysajankohtana.',
        'receptionreports.manage.monthrange': 'Raportointiväli',
        'receptionreports.manage.makereports': 'Raportoi',
        'receptionreports.manage.sendingday': 'Lähetyspäivä',
        'receptionreports.manage.sendingtime': 'Lähetysaika',
        'receptionreports.manage.receptionreports': 'Vastaanottoraportit',
        'receptionreports.manage.datatable.collectionpointoperator': 'Jätehuoltoyhtiö',
        'receptionreports.manage.datatable.latestreport': 'Viimeisin raportti',
        'receptionreports.manage.datatable.findbyname': 'Etsi nimellä',
        'receptionreports.manage.datatable.noreport': 'Ei raporttia',
        'receptionreports.manage.reporting': 'Raportoi...',
        'receptionreports.manage.sendreport': 'Lähetä',
        'receptionreports.manage.sending': 'Lähettää...',
        'receptionreports.manage.save': 'Tallenna',
        'receptionreports.manage.saving': 'Tallentaa...',
        'receptionreports.manage.nodata' : 'Ei raporttitietoja',
        'report-createtype.choose': 'Tyyppi',
        'report-type.MANUAL': 'Kerta',
        'report-type.MONTHLY': 'Kuukausi',
        'report-type.QUARTER': 'Kvartaali',
        'report-type.YEARLY': 'Vuosi',
        'report-status.choose': 'Tila',
        'report-status.REPORTSTATUS': 'Raportin tila',
        'report-status.OK': 'Ok',
        'report-status.FAIL': 'Virhe',
        'report-status.EMPTY': 'Tyhjä',
        'report-status.MAILSTATUS': 'Sähköpostin tila',
        'report-status.N/A': 'Ei lähetetty',
        'report-status.errorSendReportEmail': 'Lähetys epäonnistui',
        'report-status.errorGenerateReportEmail': 'Postin generointi epäonnistui',
        'report-status.errorReceptionReportEmail': 'Jotain meni pieleen postin lähetyksessä',
        'report-status.errorInsertReceptionReport': 'Vastaanottoraportin vienti epäonnistunut',
        'report-status.errorGenerateReceptionReport': 'Vastaanottoraportin muodostaminen epäonnistunut',
        'day-list.choose': '- Valitse lähetyspäivä -',
        'time-list.choose': '- Valitse lähetysaika -',
        'day-list.day': '. päivä',
        'day-list.quarter': '. päivä tammi-huhti-heinä-lokakuu',
        'day-list.year': '. päivä tammikuu',
        'operator-list.choose': '- Valitse yhtiö -',
        'receptionreports.browse.header': 'Selaaminen',
        'receptionreports.browse.getreports': 'Hae',
        'receptionreports.browse.datatable.latestreport': 'Viimeisin raportti',
        'receptionreports.browse.operator': 'Jätehuoltoyhtiö',
        'receptionreports.browse.startmonth': 'Alkukuukausi',
        'receptionreports.browse.endmonth': 'Loppukuukausi',
        'receptionreports.browse.attime': 'klo',
        'receptionreports.browse.receptionreports': 'Vastaanottoraportit',
        'receptionreports.browse.monthrange': 'Raportointiväli',
        'receptionreports.browse.noreportsfound': 'Valitulle aikavälille ei löytynyt raportteja',
        'receptionreports.browse.getting': 'Haetaan vastaanottoraportteja...',
        'settings.collectionpoints': 'Keräyspisteet',
        'settings.manage.header': 'Hallinta',
        'settings.operators.nodata' : 'Ei yhtiöitä',
        'settings.collectionpoints.header': 'Keräyspisteet',
        'settings.collectionpoint.header': 'Keräyspiste',
        'settings.storecollectionpoint.header': 'Kauppakeräyspiste',
        'settings.operators': 'Jätehuoltoyhtiöt',
        'settings.operators.stores': 'Kauppakeräys',
        'settings.operators.collectionpoints.findbyname': 'Etsi yhtiön tai keräyspisteen nimellä',
        'settings.operators.mailinglist': 'Sähköpostilista',
        'settings.operators.mailinglist.tip': 'Vie jätehuoltoyhtiöiden ja kauppakeräysketjujen sähköpostiosoitteet tiedostoon sähköpostilistana.',
        'settings.operators.export.mailinglist': 'Vie sähköpostilista tiedostoon...',
        'settings.operators.collectionpoints': 'Keräyspisteet',
        'settings.operator.collectionpoints': 'Keräyspisteet (* pakollinen tieto)',
        'settings.operators.addcollectionpoint': 'Lisää uusi keräyspiste',
        'settings.operators.addstorepoint': 'Lisää uusi kauppakeräyspiste',
        'settings.operators.emails': 'Sähköpostiosoitteet vastaanottoraporteille',
        'settings.operators.addemail': 'Lisää sähköposti',
        'settings.operators.autoemail': 'Lähetä vastaanottoraportti automaattisesti kerran kuukaudessa',
        'settings.operators.reportformat': 'Lapinkeräys-vastaanottoraportti',
        'settings.collectionpoints.saving': 'Tallennetaan tietoja...',
        'settings.operators.collectionpoints.empty': 'Ei keräyspisteitä',
        'settings.operators.noemails': 'Ei sähköposteja',
        'settings.collectionpoints.coordinates': 'Koordinaatit WGS84 (leveys xx.yyyyyy, pituus xx.yyyyyy): ',
        'settings.collectionpoints.crossreferences': 'Tunnisteet',
        'settings.operators.addcrossreference': 'Lisää tunniste',
        'settings.collectionpoints.inuse': 'Keräyspiste käytössä',
        'settings.collectionpoints.hasoperator': 'Keräyspiste yhtiöllä: ',
        'settings.collectionpoints.dataser': 'Data-SER keräys',
        'settings.collectionpoints.container': 'Konttikeräys',
        'settings.collectionpoints.pallet': 'Kuormalava',
        'settings.collectionpoints.notinuse': 'Keräyspiste ei käytössä',
        'settings.collectionpoints.placeholder.publicid': 'Julkinen tunnistenumero',
        'settings.collectionpoints.address': 'Osoite',
        'settings.collectionpoints.placeholder.street': 'Katuosoite',
        'settings.collectionpoints.placeholder.zip': 'Postinumero',
        'settings.collectionpoints.placeholder.city': 'Postitoimipaikka',
        'settings.collectionpoints.placeholder.community': 'Alue',
        'settings.collectionpoints.placeholder.contactinfo': 'Lisätiedot',
        'settings.collectionpoints.placeholder.lat': 'Leveysasteet',
        'settings.collectionpoints.placeholder.lon': 'Pituusasteet',
        'settings.collectionpoints.add.sorter': 'Käsittelijä',
        'settings.collectionpoints.crossreferences.add': 'Lisää uusi tunniste',
        'settings.collectionpoints.crossreferences.add.ok': 'OK',
        'settings.collectionpoints.crossreferences.add.cancel': 'Peruuta',
        'settings.operators.saving': 'Tallennetaan...',
        'settings.operators.saving.error': 'Tallennuksessa tapahtui virhe',
        'settings.operators.saving.ready': 'Tallennus valmis',
        'settings.collectionpoints.emails.add': 'Lisää sähköpostiosoite',
        'settings.collectionpoints.add.collectionpoint': 'Lisää keräyspiste',
        'settings.collectionpoints.add.storepoint': 'Lisää kauppakeräyspiste',
        'point-list.choose': 'Keräyspisteen nimi',
        'settings.collectionpoints.placeholder.id': 'Tunnistenumero',
        'settings.operators.newcollectionpoint': 'Uusi keräyspiste',
        'settings.operators.newstorepoint': 'Uusi kauppakeräyspiste',
        'settings.collectionpoint.collectionpoint.operator': 'Keräyspiste on toisella jäteyhtiöllä',
        'settings.collectionpoint.collectionpoint.operator.confirm': 'Lisää tälle jäteyhtiölle? Tallennus poistaa keräyspisteen toiselta yhtiöltä.',
        'settings.collectionpoint.collectionpoint.close': 'Kentissä on tallentamattomia muutoksia. Suljetaanko tallentamatta?',
        'settings.collectionpoints.close': 'Sulje',
        'settings.collectionpoints.ok': 'OK',
        'settings.collectionpoints.cancel': 'Peruuta',
        'settings.collectionpoints.save': 'Tallenna',
        'settings.collectionpoint.operator.exists': 'Tämän niminen jätehuoltoyhtiö on jo olemassa. Anna eri nimi, tai muokkaa olemassaolevaa yhtiötä listalta.',
        'settings.operator.add.placeholder.name': 'Yhtiön nimi',
        'settings.operator.add.collectionpoint.add': 'Lisää',
        'settings.operators.addoperator': 'Lisää uusi jätehuoltoyhtiö',
        'settings.operators.addstore': 'Lisää uusi kauppakeräysyhtiö',
        'settings.collectionpoints.collectionpoint_id': 'Tunnistenumero',
        'settings.collectionpoints.name': 'Nimi',
        'settings.collectionpoints.operational_state': 'Käytössä',
        'settings.collectionpoints.street_address': 'Osoite',
        'settings.collectionpoints.zip_code': 'Postinumero',
        'settings.collectionpoints.city': 'Kunta',
        'settings.collectionpoints.community': 'Alue',
        'settings.collectionpoints.InUse': 'Kyllä',
        'settings.collectionpoints.NotInUse': 'Ei',
        'settings.collectionpoints.container_point': 'Konttikeräys',
        'settings.collectionpoints.store_point': 'Kauppakeräys',
        'settings.collectionpoints.true': 'Kyllä',
        'settings.collectionpoints.false': 'Ei',
        'sortsummaryreports.header': 'Sisäiset raportit',
        'sortsummaryreports.costincome.header': 'Kustannukset ja tuotot',
        'sortsummaryreports.cost.header': 'Kustannukset',
        'sortsummaryreports.import': 'Kustannusten tuonti',
        'recyclingfeereports.header': 'Kierrätysmaksut',
        'recyclingfeereports.manage': 'Hallinta',
        'recyclingfeereports.numerus.reports': 'Kuukausiraportit',
        'recyclingfeereports.numerus.browse.monthrange': 'Raportointiväli',
        'recyclingfeereports.numerus.reports.month': 'Kuukausi',
        'recyclingfeereports.numerus.reports.val.fi': 'Kierrätysmaksut \nFI €',
        'recyclingfeereports.numerus.reports.val.al': 'Kierrätysmaksut \nAL €',
        'recyclingfeereports.numerus.reports.pomWeight.fi': 'POM FI \nkg',
        'recyclingfeereports.numerus.reports.pomWeight.al': 'POM AL \nkg',
        'recyclingfeereports.numerus.reports.nodata' : 'Ei raporttitietoja',
        'recyclingfeereports.numerus.manual': 'Haku Numeruksesta',
        'recyclingfeereports.numerus.manual.tip': 'Anna raportointikuukausi. Raportti tallennetaan, kun painat Tallenna-painiketta.',
        'recyclingfeereports.numerus.manual.info.exists': 'Ajanjaksolle on jo tuotu Numerus-tiedot.',
        'recyclingfeereports.numerus.manual.info.data.same': 'Tiedot eivät ole muuttuneet.',
        'recyclingfeereports.numerus.manual.info.data.diff': 'Tiedot ovat muuttuneet (sisäisen laskennan kuukausiraportti kannattaa ajaa uudelleen tallennuksen jälkeen):',
        'recyclingfeereports.numerus.settings': 'Asetukset',
        'recyclingfeereports.numerus.fetching': 'Noudetaan tietoja',
        'recyclingfeereports.numerus.saving': 'Tallennetaan tietoja',
        'recyclingfeereports.numerus.ready': 'Nouto valmis',
        'recyclingfeereports.numerus.save.ready':'Tiedot tallennettu',
        'recyclingfeereports.numerus.month': 'Kuukausi',
        'recyclingfeereports.numerus.fetch': 'Hae',
        'recyclingfeereports.numerus.save': 'Tallenna',
        'recyclingfeereports.numerus.cancel': 'Peruuta',
        'recyclingfeereports.numerus.data': 'Numerus tiedot',
        'recyclingfeereports.numerus.exists': 'Numerus-tiedot olemassa',
        'recyclingfeereports.numerus.exists.text': 'Numerus-tiedot on jo tallennettu tälle kuukaudelle. Haluatko korvata tiedot?',
        'recyclingfeereports.numerus.save.error': 'Tietojen tallennuksessa tapahtui virhe',
        'recyclingfeereports.numerus.fetch.error': 'Tietojen noutamisessa tapahtui virhe',
        'recyclingfeereports.numerus.fetch.empty': 'Ei raportoituja kierrätysmaksuja',
        'recyclingfeereports.manage.settings.tip': 'Anna Numerus-raportin noutoaikataulu. Raportti haetaan automaattisesti noutoajankohtana.',
        'recyclingfeereports.manage.fetchday': 'Noutopäivä',
        'recyclingfeereports.manage.fetchtime': 'Noutoaika',
        'sortsummaryreports.browse': 'Kustannusten selaaminen',
        'sortsummaryreports.settings': 'Kustannusasetukset',
        'sortsummaryreports.monthly': 'Kuukausiraportointi',
        'sortsummaryreports.compare': 'Raporttien vertailu',
        'sortsummaryreports.import.expenses': 'Kuljetuskustannukset',
        'sortsummaryreports.import.header': 'Tuonti',
        'sortsummaryreports.import.sorter': 'Käsittelijä',
        'sortsummaryreports.import.saving':'Tallennetaan...',
        'sortsummaryreports.import.ready':'Raportit tallennettu',
        'sortsummaryreports.save.ready':'Raportti tallennettu',
        'sortsummaryreports.import.selectcostincome': 'Tuotava kulu tai tulo',
        'summaryreport.error.1': 'Kuljetuskustannusraportti on jo tuotu tietokantaan, laskunumero: ',
        'summaryreport.error.2': 'Kuljetuskustannusraportilta ei löytynyt käsittelijää (rivi): ',
        'summaryreport.error.3': 'Virhe lukiessa kuljetuskustannusraporttia ',
        'summaryreport.error.4': 'Käsittelyraportin käsittelijää ei löydy tällä nimellä: ',
        'summaryreport.error.5': 'Käsittelyraportti on jo tuotu tälle käsittelijälle, tyypille ja ajalle: ',
        'summaryreport.error.6': 'Käsittelyraportin laskutuskausi on eri kuin käyttäjän syöttämä kausi: ',
        'summaryreport.error.7': 'Kuljetuskustannusraportin kaikkien rivien päiväys on eri kuin käyttäjän syöttämä kausi: ',
        'summaryreport.error.8': 'Valittu käsittelijä ei vastaa käsittelyraportilla olevaa käsittelijänimeä: ',
        'summaryreport.error.9': 'Käsittelyraportilla olevan “yhteensä”-rivin paino tai hinta ei vastaa rivien summattua painoa/hintaa.',
        'summaryreport.error.10': 'Käsittelyraporttityypin tallennuksessa tapahtui virhe.',
        'summaryreport.error.11': 'Kuukausiraportin tallennuksessa tapahtui virhe.',
        'summaryreport.error.12': 'Käsittelijäviittausten haussa tapahtui virhe.',
        'summaryreport.error.13': 'Sisäinen kuukausiraportti on jo olemassa ko. ajanjaksolle.',
        'summaryreport.error.14': 'Kuukausiraportin laskennassa tapahtui virhe.',
        'summaryreport.error.15': 'Ajanjaksolle ei ole käsittelytietoa tietokannassa.',
        'summaryreport.error.16': 'Kuljetuskustannusten lukemisessa tapahtui virhe.',
        'summaryreport.error.17': 'Raportilta puuttuvat sarakkeet: ',
        'summaryreport.error.18': 'Väärä materiaali/kategoria (rivi): ',
        'summaryreport.error.19': 'Laskunumero ei saa olla tyhjä tai nolla, virhe rivillä: ',
        'summaryreport.error.20': 'Kuljetuskustannusraportilla ei ole yhtään riviä.',
        'summaryreport.error.21': 'Käsittelyraportti on väärää muotoa tai “Käsittely“-välilehti puuttuu.',
        'summaryreport.error.22': 'Käsittelyraportin laskutuskauden päivämäärät ovat väärässä muodossa. Hyväksyttävät muodot ovat “1.2.-28.2.2021” ja “Helmikuu 2021”. Väärän muotoinen kausi: ',
        'summaryreport.error.23': 'Virhe kyselyssä: väärä raporttityyppi.',
        'summaryreport.error.24': 'Raporttitietoja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.25': 'Vertailutietojen haussa tapahtui virhe. ',
        'summaryreport.error.26': 'Metallihyvityksiä ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.27': 'Kustannustietoja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.28': 'Kierrätysmaksuja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.29': 'Tunnuslukuja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.30': 'Metallihyvityksiä ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.31': 'Kierrätysmaksuja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.32': 'Tunnuslukuja ei ole tallennettu aikajaksolle: ',
        'summaryreport.error.33': 'Kuljetusliikkeen nimi ei vastaa kuljetusliikeen id:tä kuljetuskustannusraportilla (rivi): ',
        'summaryreport.error.34': 'Kuljetuskustannusraportin kuljetusliikettä ei löydy tunnuksella (rivi): ',
        'summaryreport.error.35': 'Kuljetuskustannusraportin keräyspistettä ei löydy tunnuksella (rivi): ',
        'summaryreport.error.36': 'Kuljetuskustannusraportti on jo tuotu tälle kuljetusyhtiölle ja laskunumerolle: ',
        'summaryreport.error.37': 'Rajapintakutsusta puuttuu aikaväli. ',
        'summaryreport.error.38': 'Ajanjaksolle ei ole Numerus-dataa tietokannassa.',
        'summaryreport.error.39': 'Numerus-datan haussa tapahtui virhe.',
        'transportsummaryreports.import.header': 'Kuljetuskustannukset',
        'transportsummaryreports.import.handlingreport': 'Käsittelyraportti',
        'transportsummaryreports.import.resulttable.header': 'Kuljetuskustannukset SER-luokittain',
        'transportsummaryreports.import.resulttable.km': 'km',
        'transportsummaryreports.import.resulttable.eur': '€',
        'transportsummaryreports.import.resulttable.eurPct': '€%',
        'transportsummaryreports.import.resulttable.sum': 'Yhteensä',
        'transportsummaryreports.import.accept': 'Hyväksy ja tallenna',
        'transportsummaryreports.import.reject': 'Hylkää',
        'transportsummaryreports.import.resulttable.ce': 'CE',
        'transportsummaryreports.import.resulttable.sda': 'SDA',
        'transportsummaryreports.import.resulttable.lda': 'LDA',
        'transportsummaryreports.import.resulttable.cool': 'COLD',
        'transportsummaryreports.import.resulttable.crt': 'CRT',
        'transportsummaryreports.import.resulttable.total': 'Yhteensä',
        'sortsummaryreports.import.resulttable.header': 'Käsitelty SER',
        'sortsummaryreports.import.resulttable.kg': 'kg',
        'sortsummaryreports.import.resulttable.eur': '€',
        'sortsummaryreports.import.resulttable.eurKg': '€/kg',
        'sortsummaryreports.import.resulttable.WEEE1': 'WEEE1 - Suuret kodinkoneet',
        'sortsummaryreports.import.resulttable.WEEE2': 'WEEE2 - Pienet kodinkoneet',
        'sortsummaryreports.import.resulttable.WEEE3': 'WEEE3 - Tieto- ja teletekniikka',
        'sortsummaryreports.import.resulttable.WEEE4': 'WEEE4 - Kuluttajaelektroniikka',
        'sortsummaryreports.import.resulttable.WEEE5': 'WEEE5 - Valaistuslaitteet',
        'sortsummaryreports.import.resulttable.WEEE6': 'WEEE6 - Työkalut',
        'sortsummaryreports.import.resulttable.WEEE7': 'WEEE7 - Lelut, vapaa-aika, urheilu',
        'sortsummaryreports.import.resulttable.WEEE8': 'WEEE8 - Terveydenhuollon laitteet',
        'sortsummaryreports.import.resulttable.WEEE9': 'WEEE9 - Tarkkailu- ja valvontalaitteet',
        'sortsummaryreports.import.resulttable.lda': 'Suuret kodinkoneet',
        'sortsummaryreports.import.resulttable.cold': 'Kylmälaitteet, lämpöpumput',
        'sortsummaryreports.import.resulttable.scrap': 'Muut',
        'sortsummaryreports.import.resulttable.solar': 'Aurinkopaneelit',
        'sortsummaryreports.import.resulttable.sda': 'Pienet kodinkoneet',
        'sortsummaryreports.import.resulttable.ict': 'Tietokoneet',
        'sortsummaryreports.import.resulttable.monitors': 'Näytöt',
        'sortsummaryreports.import.resulttable.ce': 'Kuluttajaelektroniikkalaitteet',
        'sortsummaryreports.import.resulttable.crt': 'Televisiot',
        'sortsummaryreports.import.resulttable.music': 'Musiikki',
        'sortsummaryreports.import.resulttable.firealarms': 'Palovaroittimet',
        'sortsummaryreports.import.resulttable.monitoring': 'Tarkkailu- ja valvontalaitteet',
        'sortsummaryreports.import.error': 'Tietokantaan tallennuksessa tapahtui virhe.',
        'sortsummaryreports.import.getting': 'Haetaan tietoja...',
        'sortsummaryreports.browse.header': 'Selaaminen',
        'sortsummaryreports.browse.getting': 'Haetaan käsittelyraportteja...',
        'sortsummaryreports.browse.reporttype': 'Raporttityyppi',
        'sortsummaryreports.browse.monthrange': 'Raportointiväli',
        'sortsummaryreports.browse.datatable.name': 'Nimike',
        'sortsummaryreports.browse.datatable.km': 'km',
        'sortsummaryreports.browse.datatable.eur': '€',
        'sortsummaryreports.browse.datatable.eurpct': '€%',
        'sortsummaryreports.browse.datatable.COLD': 'Kylmälaitteet (COLD)',
        'sortsummaryreports.browse.datatable.CE': 'Viihde-elektroniikka (Ce)',
        'sortsummaryreports.browse.datatable.CRT': 'TV:t ja näytöt (CRT)',
        'sortsummaryreports.browse.datatable.LDA': 'Kodinkoneet (LDA)',
        'sortsummaryreports.browse.datatable.SDA': 'Pien-SER (SDA)',
        'sortsummaryreports.browse.datatable.WEEE': 'WEEE-luokka',
        'sortsummaryreports.browse.datatable.codes': 'Alaluokat',
        'sortsummaryreports.browse.datatable.description': 'Luokan kuvaus',
        'sortsummaryreports.browse.datatable.kg': 'kg',
        'sortsummaryreports.browse.datatable.eurKg': '€/kg',
        'sortsummaryreports.browse.datatable.lda': 'Suuret kodinkoneet',
        'sortsummaryreports.browse.datatable.cold': 'Kylmälaitteet, lämpöpumput',
        'sortsummaryreports.browse.datatable.scrap': 'Muut',
        'sortsummaryreports.browse.datatable.solar': 'Aurinkopaneelit',
        'sortsummaryreports.browse.datatable.sda': 'Pienet kodinkoneet',
        'sortsummaryreports.browse.datatable.ict': 'Tietokoneet',
        'sortsummaryreports.browse.datatable.monitors': 'Näytöt',
        'sortsummaryreports.browse.datatable.ce': 'Kuluttajaelektroniikkalaitteet',
        'sortsummaryreports.browse.datatable.crt': 'Televisiot',
        'sortsummaryreports.browse.datatable.music': 'Musiikki',
        'sortsummaryreports.browse.datatable.lamps': 'Valaistuslaitteet',
        'sortsummaryreports.browse.datatable.elTools': 'Sähkö- ja elektroniikkatyökalut',
        'sortsummaryreports.browse.datatable.toys': 'Lelut ja vapaa-aika',
        'sortsummaryreports.browse.datatable.health': 'Terveydenhuollon laitteet',
        'sortsummaryreports.browse.datatable.firealarms': 'Palovaroittimet',
        'sortsummaryreports.browse.datatable.monitoring': 'Tarkkailu- ja valvontalaitteet',
        'sortsummaryreports.browse.datatable.WEEE1': 'WEEE1 - Suuret kodinkoneet',
        'sortsummaryreports.browse.datatable.WEEE2': 'WEEE2 - Pienet kodinkoneet',
        'sortsummaryreports.browse.datatable.WEEE3': 'WEEE3 - Tieto- ja teletekniikka',
        'sortsummaryreports.browse.datatable.WEEE4': 'WEEE4 - Kuluttajaelektroniikka',
        'sortsummaryreports.browse.datatable.WEEE5': 'WEEE5 - Valaistuslaitteet',
        'sortsummaryreports.browse.datatable.WEEE6': 'WEEE6 - Työkalut',
        'sortsummaryreports.browse.datatable.WEEE7': 'WEEE7 - Lelut, vapaa-aika, urheilu',
        'sortsummaryreports.browse.datatable.WEEE8': 'WEEE8 - Terveydenhuollon laitteet',
        'sortsummaryreports.browse.datatable.WEEE9': 'WEEE9 - Tarkkailu- ja valvontalaitteet',
        'sortsummaryreports.settings.header': 'Asetukset',
        'sortsummaryreports.settings.weeeclasses': 'WEEE-luokat',
        'sortsummaryreports.settings.containercosts': 'Konttikustannukset',
        'sortsummaryreports.settings.eur': '€',
        'sortsummaryreports.settings.eurkg': '€/kg',
        'sortsummaryreports.settings.lda': 'Kodinkoneet (LDA)',
        'sortsummaryreports.settings.cool': 'Kylmälaitteet (COLD)',
        'sortsummaryreports.settings.sda': 'Pien-SER, TV:t ja näytöt, pienelektroniikka (SDA, CRT, Ce)',
        'sortsummaryreports.settings.total': 'Yhteensä',
        'sortsummaryreports.settings.receptioncost': 'Vastaanottokustannus',
        'sortsummaryreports.settings.edited': 'Muokattu',
        'sortsummaryreports.settings.reset': 'Palauta',
        'sortsummaryreports.settings.save': 'Tallenna',
        'sortsummaryreports.settings.getting': 'Haetaan asetuksia...',
        'sortsummaryreports.settings.saving': 'Tallennetaan asetuksia...',
        'summaryreport.header': 'Sisäisen laskennan kuukausiraportti',
        'summaryreport.reportmonth': 'Raportointikuukausi',
        'summaryreport.reportdata': 'Tarvittavat raportointitiedot',
        'summaryreport.calculate': 'Laske',
        'summaryreport.getting': 'Lasketaan...',
        'summaryreport.saving': 'Tallennetaan...',
        'summaryreport.costreport': 'Kustannusraportti',
        'summaryreport.datatable.name': 'Luokka',
        'summaryreport.datatable.codes': 'Alaluokat',
        'summaryreport.datatable.description': 'Luokan kuvaus',
        'summaryreport.datatable.kg': 'C/T \nkg',
        'summaryreport.datatable.eur': 'C/T \nYhteensä €',
        'summaryreport.datatable.eurKg': 'C/T \n€/kg',
        'summaryreport.datatable.handling': 'Käsittely\n€',
        'summaryreport.datatable.transport': 'Kuljetus\n€',
        'summaryreport.datatable.receiving': 'Vastaanotto\n€',
        'summaryreport.datatable.containers': 'Kontit\n€',
        'summaryreport.datatable.fee': 'POM \nKK-maksut €',
        'summaryreport.datatable.pomKg': 'POM kg',
        'summaryreport.datatable.pomKgRate': 'C/T / POM \n kg \nkeräysaste %',
        'summaryreport.datatable.feeEurKg': 'POM KK-maksut \n(€) / C/T (kg) \n€/kg',
        'summaryreport.datatable.deviation': 'POM KK-maksut \n(€/kg)  - C/T (€/kg ) \nero',
        'summaryreport.datatable.fee_fi': 'POM FI \nKK-maksut €',
        'summaryreport.datatable.fee_al': 'POM AL \nKK-maksut €',
        'summaryreport.datatable.pomPcs_fi': 'Kpl FI',
        'summaryreport.datatable.pomPcs_al': 'Kpl AL',
        'summaryreport.reset': 'Peruuta',
        'summaryreport.save': 'Tallenna',
        'summaryreport.exists': 'Kuukausiraportti olemassa',
        'summaryreport.exists.text': 'Kuukausiraportti on jo laskettu ja tallennettu tälle kuukaudelle. Haluatko korvata raportin uudella? Vanhat lasketut raporttitiedot poistetaan.',
        'summaryreport.metrics': 'Tunnusluvut',
        'summaryreport.browse.datatable.weee1lda': 'Suuret kodinkoneet',
        'summaryreport.browse.datatable.weee1cold': 'Kylmälaitteet, lämpöpumput',
        'summaryreport.browse.datatable.weee1solarpanels': 'Aurinkopaneelit',
        'summaryreport.browse.datatable.weee1other': 'Muu talotekniikka',
        'summaryreport.browse.datatable.weee2sda': 'Pienet kodinkoneet',
        'summaryreport.browse.datatable.weee2other': 'Kellot',
        'summaryreport.browse.datatable.weee3ict': 'Tietokoneet',
        'summaryreport.browse.datatable.weee3monitors': 'Näytöt',
        'summaryreport.browse.datatable.weee3other': 'Muu tietotekniikka',
        'summaryreport.browse.datatable.weee4ce': 'Kuluttajaelektroniikkalaitteet',
        'summaryreport.browse.datatable.weee4crt': 'Televisiot',
        'summaryreport.browse.datatable.weee4music': 'Musiikki',
        'summaryreport.browse.datatable.weee5lamps': 'Valaistuslaitteet',
        'summaryreport.browse.datatable.weee6eltools': 'Sähkö- ja elektroniikkatyökalut',
        'summaryreport.browse.datatable.weee7toys': 'Lelut ja vapaa-aika',
        'summaryreport.browse.datatable.weee8health': 'Terveydenhuollon laitteet',
        'summaryreport.browse.datatable.weee9firealarms': 'Palovaroittimet',
        'summaryreport.browse.datatable.weee9monitoringtools': 'Tarkkailu- ja valvontalaitteet',
        'summaryreport.browse.datatable.totals': 'Yhteensä',
        'summaryreport.browse.datatable.sum_lda_total': 'Suuret kodinkoneet',
        'summaryreport.browse.datatable.sum_cold_total': 'Kylmälaitteet',
        'summaryreport.browse.datatable.sum_mon_tv_total': 'Näytöt, TV:t',
        'summaryreport.browse.datatable.sum_solar_total': 'Aurinkopaneelit',
        'summaryreport.browse.datatable.sum_other_total': 'Pienet kodinkoneet ja laitteet',
        'summaryreport.browse.datatable.lamps': 'Lamput ja loisteputket',
        'summaryreport.browse.datatable.lda': 'LDA',
        'summaryreport.browse.datatable.cool': 'COOL',
        'summaryreport.browse.datatable.crt': 'CRT',
        'summaryreport.browse.datatable.ict': 'ICT',
        'summaryreport.browse.datatable.sda': 'SDA',
        'summaryreport.browse.datatable.ce': 'CE',
        'summaryreport.browse.datatable.solar': 'Aurinkopaneelit',
        'summaryreport.noreportsfound': 'Raporttia ei löytynyt tai sen haussa tapahtui virhe',
        'summaryreport.options.tab1': 'Kustannusasetukset',
        'summaryreport.options.tab2': 'WEEE-luokat',
        'summaryreport.error': 'Raportin tallennuksessa tapahtui virhe',
        'comparereports.header': 'Kuukausiraporttien vertailu',
        'comparereports.monthrange': 'Raportointiväli',
        'comparereports.comparerange': 'Vertailuväli',
        'comparereports.get': 'Hae',
        'comparereports.reports': 'Raportit',
        'comparereports.fees': 'Kierrätysmaksut',
        'comparereports.metrics': 'Tunnusluvut',
        'comparereports.ratios': 'Suhdeluvut',
        'comparereports.month': 'Kuukausiväli',
        'comparereports.year': 'Vuosi',
        'comparereports.q': 'Kvartaali',
        'comparereports.prevyear': 'Edelliset 12kk',
        'comparereport.getting': 'Haetaan tietoja...',
        'comparereport.datatable.difference': 'Erotus',
        'comparereport.datatable.pct': '%',
        'comparereport.datatable.eur': '€',
        'comparereport.datatable.eurKg': '€/kg',
        'comparereport.datatable.description': 'Tunnusluku',
        'comparereport.datatable.handling': 'Käsittely',
        'comparereport.datatable.containers': 'Kontit',
        'comparereport.datatable.receiving': 'Vastaanotto',
        'comparereport.datatable.transport': 'Kuljetus',
        'comparereport.datatable.metal_refunds': 'Metalli-\nhyvitykset',
        'comparereport.datatable.recycle_fees': 'Kierrätys-\nmaksut',
        'comparereport.datatable.total_income': 'Tuotot yhteensä',
        'comparereport.datatable.total_cost': 'Kulut yhteensä',
        'comparereport.datatable.month': 'Kuukausi',
        'comparereport.datatable.handling_per_income': 'Käsittely/\ntuotot',
        'comparereport.datatable.transport_per_income': 'Kuljetus/\ntuotot',
        'comparereport.datatable.receiving_per_income': 'Vastaanotto/\ntuotot',
        'comparereport.datatable.recycling_per_cost': 'Kierrätys/\nkulut',
        'comparereport.datatable.recycling_per_income': 'Kierrätys/\ntuotot',
        'comparereport.datatable.refund_per_income': 'Metallih./\ntuotot',
        'comparereport.datatable.cost_per_income': 'Kulut/\ntuotot',
        'comparereport.datatable.cost': 'Kulut\nyhteensä',
        'comparereport.datatable.income': 'Tuotot\nyhteensä',
        'comparereport.datatable.export': 'Vie tiedostoon...',
        'trafficlights.header.handling' : 'Käsittelykustannukset',
        'trafficlights.header.transport' : 'Kuljetuskustannukset',
        'trafficlights.header.receiving' : 'Vastaanottokustannukset',
        'trafficlights.header.containers' : 'Konttikustannukset',
        'trafficlights.header.recycling' : 'Kierrätysmaksut',
        'trafficlights.header.existing' : 'Sisäisen laskennan kuukausiraportti laskettu',
        'trafficlights.error.33' : 'Konttikustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.34' : 'Suurten kondinkoneiden (LDA) konttikustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.35' : 'Kylmälaitteiden (COOL) konttikustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.36' : 'Pienien kodinkoneiden, TV:iden ja näyttöjen ja kuluttajaelektroniikan (SDA, CE, CRT) konttikustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.37' : 'Vastaanottokustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.38' : 'Vastaanottokustannusten yksikköhintaa ei ole syötetty ajalle: ',
        'trafficlights.error.39' : 'Kuljetuskustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.40' : 'Kuljetuskustannuksia ei ole syötetty kuljetusyhtiölle: ',
        'trafficlights.error.41' : 'Kuljetuskustannuksia ei ole syötetty kuljetusyhtiöiltä jäteluokille (ei pakollisia): ',
        'trafficlights.error.42' : 'Kuljetuskustannuksia ei ole syötetty kuljetusyhtiöiltä jäteluokille (pakollisia):',
        'trafficlights.error.43' : 'Käsittelykustannuksia ei ole syötetty ajalle: ',
        'trafficlights.error.44' : 'Käsittelykustannuksia ei ole syötetty jätehuoltoyhtiölle ajalle: ',
        'trafficlights.error.45' : 'Käsittelykustannuksia ei ole syötetty jätehuoltoyhtiöiltä jäteluokille (ei pakollisia): ',
        'trafficlights.error.46' : 'Käsittelykustannuksia ei ole syötetty jätehuoltoyhtiöiltä jäteluokille (pakollisia): ',
        'trafficlights.error.47' : 'Kierrätysmaksuja ei ole syötetty ajalle: ',
        'trafficlights.showmore' : 'Katso lisätiedot',
        'trafficlights.header.sorter' : ' ',
        'trafficlights.header.green' : 'Tiedot ok',
        'trafficlights.header.yellow' : 'Tietoja puuttuu',
        'trafficlights.header.red' : 'Kaikki tiedot puuttuvat',
        'trafficlights.error.49' : 'Kiloja ei ole syötetty tälle käsittelijälle tässä kuussa. ',
        'trafficlights.error.50' : 'Tuotuja kiloja puuttuu tässä kuussa ei-pakollisista jäteluokista: ',
        'trafficlights.error.51' : 'Tuotuja kiloja puuttuu tässä kuussa pakollisista jäteluokista: ',
        'trafficlights.error.58' : 'Sisäisen laskennan kuukausiraportti on jo laskettu kuukaudelle: ',
        'trafficlights.error.59' : 'Sisäisen laskennan kuukausiraporttia ei ole laskettu kuukaudelle: ',
        'calendar.select.month': 'Valitse kuukausi',
        'calendar.select.start': 'Aloitus',
        'calendar.select.end': 'Lopetus',
        'button.open.calendar': 'Avaa kalenteri',
        'button.error.reload': 'Palaa työpöydälle',
        'error.boundary.info': 'Lähetä seuraavat virhetiedot Sernet-ylläpitoon: ',
        'error.boundary.header': 'Tapahtui odottamaton virhe'
    },
    'en-GB': {
    },

  };

  export default LocalizedStrings;
